// SOLUCIÓN URGENTE - REEMPLAZAR TODO EL CONTENIDO DE pacienteService.js con esto:

import axios from 'axios';

// Crear instancia de axios sin usar el wrapper api.js problemático
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor simple para el token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const pacienteService = {
  // VERSIÓN CORREGIDA DE getPacientes
  getPacientes: async (params = {}) => {
    
    // FORZAR conversión a tipos primitivos
    let pageValue = 1;
    let limitValue = 10;
    
    // Extraer page de cualquier forma que venga
    if (params.page !== undefined && params.page !== null) {
      if (typeof params.page === 'object') {
        console.warn('⚠️ page es un objeto:', params.page);
        // Intentar extraer valor de diferentes formas
        pageValue = params.page.value || params.page.page || params.page.current || 1;
      } else {
        pageValue = params.page;
      }
    }
    
    // Asegurar que sea número
    pageValue = parseInt(pageValue) || 1;
    limitValue = parseInt(params.limit) || 10;
    
   
    try {
      // Construir URL manualmente para evitar problemas
      const baseUrl = `${process.env.REACT_APP_API_URL}/pacientes`;
      const queryParams = new URLSearchParams({
        page: pageValue.toString(),
        limit: limitValue.toString()
      });
      
      // Agregar otros parámetros si existen
      if (params.search) queryParams.append('search', params.search);
      if (params.estado) queryParams.append('estado', params.estado);
      if (params.especialista_id) queryParams.append('especialista_id', params.especialista_id);
      if (params.especialidad_id) queryParams.append('especialidad_id', params.especialidad_id);
      
      const fullUrl = `${baseUrl}?${queryParams.toString()}`;
      
      
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('NO HAY TOKEN');
        throw new Error('No autenticado');
      }
      
      // Hacer petición directa con fetch para evitar interceptores problemáticos
      const response = await fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.status === 401) {
        console.error('Error 401 - Token inválido');
        localStorage.removeItem('token');
        window.location.href = '/login';
        throw new Error('Sesión expirada');
      }
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Retornar en formato esperado por el componente
      return { data };
      
    } catch (error) {
      console.error('Error en getPacientes:', error);
      throw error;
    }
  },
  
  // Mantener las demás funciones pero usando apiClient en lugar de api
  getPaciente: async (id) => {
    if (!id || id === 'undefined') {
      console.error('ID de paciente no válido:', id);
      throw new Error('ID de paciente no válido');
    }
    try {
      const response = await apiClient.get(`/pacientes/${id}`);
      const especialistasResponse = await apiClient.get(`/pacientes/${id}/especialistas`);
      
      if (especialistasResponse.data && Array.isArray(especialistasResponse.data)) {
        response.data.especialistas = especialistasResponse.data;
      }
      
      return response;
    } catch (error) {
      console.error(`Error fetching paciente ${id}:`, error);
      throw error;
    }
  },

  getPacienteEspecialistas: async (pacienteId) => {
    try {
      return await apiClient.get(`/pacientes/${pacienteId}/especialistas`);
    } catch (error) {
      console.error(`Error fetching especialistas for paciente ${pacienteId}:`, error);
      throw error;
    }
  },

  asignarEspecialista: async (pacienteId, especialistaId, especialidadId, motivo = '') => {
  try {
    const payload = {
      pacienteId: parseInt(pacienteId),
      especialistaId: parseInt(especialistaId),
      especialidadId: parseInt(especialidadId),
      motivo: motivo || 'Asignación desde formulario de paciente'
    };
    
    const response = await apiClient.post('/pacientes/asignar-especialista', payload);
    
    return response.data;
  } catch (error) {
    // 🔍 DEBUG: Ver exactamente qué error devuelve el backend
    console.error('❌ ERROR DETALLADO DEL BACKEND:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message,
      config: {
        url: error.config?.url,
        method: error.config?.method,
        data: error.config?.data
      }
    });
    
    throw error;
  }
},

  getPacientesByEspecialista: async (especialistaId) => {
    return await apiClient.get(`/pacientes/especialista/${especialistaId}`);
  },

  desasignarEspecialista: async (pacienteId, especialistaId, motivo = '') => {
    if (!pacienteId || !especialistaId) {
      console.error('Error: Datos incompletos para desasignación de especialista');
      throw new Error('Paciente y especialista son requeridos');
    }
    
    try {
      const payload = {
        pacienteId: parseInt(pacienteId),
        especialistaId: parseInt(especialistaId),
        motivo: motivo || 'Desasignación desde formulario de paciente'
      };
      
      const response = await apiClient.post('/pacientes/desasignar-especialista', payload);
      return response.data;
    } catch (error) {
      console.error(`Error desasignando especialista del paciente ${pacienteId}:`, error.response || error);
      throw error;
    }
  },

  createPaciente: async (pacienteData) => {
    try {
      const processedData = sanitizeDataForDB(pacienteData);
      
      if (pacienteData.fotoFile) {
        const formData = new FormData();
        formData.append('foto', pacienteData.fotoFile);
        
        Object.keys(processedData).forEach(key => {
          if (key !== 'fotoFile' && key !== 'foto') {
            if (typeof processedData[key] === 'object' && processedData[key] !== null) {
              formData.append(key, JSON.stringify(processedData[key]));
            } else if (processedData[key] !== undefined && processedData[key] !== null) {
              formData.append(key, processedData[key]);
            }
          }
        });
        
        const response = await apiClient.post('/pacientes', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return response;
      } else {
        const response = await apiClient.post('/pacientes', processedData);
        return response;
      }
    } catch (error) {
      console.error('Error creating paciente:', error);
      throw error;
    }
  },
  
  updatePaciente: async (id, pacienteData) => {
    try {
      const processedData = sanitizeDataForDB(pacienteData);
      
      if (pacienteData.fotoFile) {
        const formData = new FormData();
        formData.append('foto', pacienteData.fotoFile);
        
        Object.keys(processedData).forEach(key => {
          if (key !== 'fotoFile' && key !== 'foto') {
            if (typeof processedData[key] === 'object' && processedData[key] !== null) {
              formData.append(key, JSON.stringify(processedData[key]));
            } else if (processedData[key] !== undefined && processedData[key] !== null) {
              formData.append(key, processedData[key]);
            }
          }
        });
        
        const response = await apiClient.put(`/pacientes/${id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return response;
      } else {
        const response = await apiClient.put(`/pacientes/${id}`, processedData);
        return response;
      }
    } catch (error) {
      console.error(`Error updating paciente ${id}:`, error);
      throw error;
    }
  },

  deletePaciente: async (id) => {
    try {
      return await apiClient.delete(`/pacientes/${id}`);
    } catch (error) {
      console.error(`Error deleting paciente ${id}:`, error);
      throw error;
    }
  },

  getHistorial: async (id) => {
    try {
      return await apiClient.get(`/pacientes/${id}/historias`);
    } catch (error) {
      console.error(`Error fetching historias for paciente ${id}:`, error);
      throw error;
    }
  },

  getCitas: async (pacienteId) => {
    try {
      return await apiClient.get(`/pacientes/${pacienteId}/citas`);
    } catch (error) {
      console.error(`Error fetching citas for paciente ${pacienteId}:`, error);
      throw error;
    }
  },
  
  registrarCambioEstado: async (pacienteId, cambioData) => {
    try {
      return await apiClient.post(`/cambios-estado-paciente/paciente/${pacienteId}`, cambioData);
    } catch (error) {
      console.error(`Error registering estado change for paciente ${pacienteId}:`, error);
      throw error;
    }
  },

  getCambiosEstadoPaciente: async (pacienteId) => {
    try {
      return await apiClient.get(`/cambios-estado-paciente/paciente/${pacienteId}`);
    } catch (error) {
      console.error(`Error fetching estado changes for paciente ${pacienteId}:`, error);
      throw error;
    }
  },

  getApoderados: async (pacienteId) => {
    try {
      const response = await apiClient.get(`/pacientes/${pacienteId}/apoderados`);
      return response;
    } catch (error) {
      console.error(`Error fetching apoderados for paciente ${pacienteId}:`, error);
      throw error;
    }
  },

  createApoderado: async (pacienteId, apoderado) => {
    if (!pacienteId) {
      console.error('Error: ID de paciente no proporcionado');
      throw new Error('ID de paciente es requerido para crear un apoderado');
    }
    
    if (!apoderado.nombres || !apoderado.apellidos) {
      console.error('Error: Nombres y apellidos son requeridos');
      throw new Error('Nombres y apellidos son requeridos para crear un apoderado');
    }
    
    try {
      const { isNew, isModified, id: tempId, ...apoderadoData } = apoderado;
      
      if (pacienteId) {
        apoderadoData.paciente_id = pacienteId;
      }
      
      const response = await apiClient.post(`/pacientes/${pacienteId}/apoderados`, apoderadoData);
      return response;
    } catch (error) {
      console.error(`Error creating apoderado for paciente ${pacienteId}:`, error);
      throw error;
    }
  },

  updateApoderado: async (pacienteId, apoderadoId, apoderadoData) => {
    try {
      const response = await apiClient.put(`/pacientes/${pacienteId}/apoderados/${apoderadoId}`, apoderadoData);
      return response;
    } catch (error) {
      console.error(`Error updating apoderado ${apoderadoId}:`, error);
      throw error;
    }
  },

  deleteApoderado: async (pacienteId, apoderadoId) => {
    try {
      const response = await apiClient.delete(`/pacientes/${pacienteId}/apoderados/${apoderadoId}`);
      return response;
    } catch (error) {
      console.error(`Error deleting apoderado ${apoderadoId}:`, error);
      throw error;
    }
  },

  getDocumentos: async (pacienteId) => {
    try {
      const response = await apiClient.get(`/pacientes/${pacienteId}/documentos`);
      return response;
    } catch (error) {
      console.error(`Error fetching documentos for paciente ${pacienteId}:`, error);
      throw error;
    }
  },

  uploadDocumento: async (pacienteId, formData) => {
    try {
      const response = await apiClient.post(`/pacientes/${pacienteId}/documentos`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      console.error(`Error uploading documento for paciente ${pacienteId}:`, error);
      throw error;
    }
  },

  downloadDocumento: async (pacienteId, documentoId) => {
    try {
      const response = await apiClient.get(`/pacientes/${pacienteId}/documentos/${documentoId}/download`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error(`Error downloading documento ${documentoId}:`, error);
      throw error;
    }
  },

  deleteDocumento: async (pacienteId, documentoId) => {
    try {
      const response = await apiClient.delete(`/pacientes/${pacienteId}/documentos/${documentoId}`);
      return response;
    } catch (error) {
      console.error(`Error deleting documento ${documentoId}:`, error);
      throw error;
    }
  },

  cambiarEstado: async (pacienteId, nuevoEstado, observaciones = '') => {
    try {
      return await apiClient.put(`/pacientes/${pacienteId}/cambiar-estado`, {
        nuevo_estado: nuevoEstado,
        observaciones
      });
    } catch (error) {
      console.error(`Error changing estado for paciente ${pacienteId}:`, error);
      throw error;
    }
  },

  getPacientesConInasistencias: async (limite = 2) => {
    try {
      return await apiClient.get('/pacientes/inasistencias', {
        params: { limite }
      });
    } catch (error) {
      console.error('Error fetching pacientes con inasistencias:', error);
      throw error;
    }
  }
};

// Función utilitaria para preprocesar datos antes de enviarlos al servidor
function sanitizeDataForDB(data) {
  const sanitizedData = { ...data };
  const enumFields = ['lateralidad', 'sexo'];
  
  enumFields.forEach(field => {
    if (sanitizedData[field] === '' || sanitizedData[field] === undefined) {
      sanitizedData[field] = null;
    }
  });
  
  if (sanitizedData.fotoFile) {
    delete sanitizedData.fotoFile;
  }
  
  return sanitizedData;
}

export default pacienteService;